import { X } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useInAppUrlViewStore } from '@/stores/inAppUrlViewStore';
import { createPortal } from 'react-dom';

export function AttachmentUrlOverlay() {
  const url = useInAppUrlViewStore((s) => s.url);
  const clear = useInAppUrlViewStore((s) => s.clear);

  if (!url) return null;

  const overlay = (
    <dialog
      className="fixed inset-0 z-[100] flex flex-col bg-background border-0 p-0 m-0"
      aria-label="Fichier"
      open
    >
      <div className="flex items-center justify-end shrink-0 p-2 border-b bg-background">
        <Button
          variant="ghost"
          size="icon"
          onClick={clear}
          className="rounded-full"
          aria-label="Fermer"
        >
          <X className="h-5 w-5" />
        </Button>
      </div>
      <div className="flex-1 min-h-0 w-full">
        <iframe
          src={url}
          className="w-full h-full border-0"
          title="Fichier"
        />
      </div>
    </dialog>
  );

  return createPortal(overlay, document.body);
}
